const BASIC_CHECKOUT_RETURN_KEY = 'arsenal_basic_checkout_return'
const CHECKOUT_RETURN_WINDOW_MS = 30 * 60 * 1000

export function markBasicCheckoutReturn(): void {
  if (typeof window === 'undefined') return

  window.sessionStorage.setItem(
    BASIC_CHECKOUT_RETURN_KEY,
    Date.now().toString(),
  )
}

export function hasPendingBasicCheckoutReturn(): boolean {
  if (typeof window === 'undefined') return false

  const storedTimestamp = window.sessionStorage.getItem(
    BASIC_CHECKOUT_RETURN_KEY,
  )
  const timestamp = Number(storedTimestamp)

  if (!storedTimestamp || !Number.isFinite(timestamp)) return false

  if (Date.now() - timestamp > CHECKOUT_RETURN_WINDOW_MS) {
    clearBasicCheckoutReturn()
    return false
  }

  return true
}

export function clearBasicCheckoutReturn(): void {
  if (typeof window === 'undefined') return

  window.sessionStorage.removeItem(BASIC_CHECKOUT_RETURN_KEY)
}
